import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.71 12.97c.22.22.57.22.79 0l3.02-3.02c.22-.22.22-.57 0-.79a.555.555 0 0 0-.79 0l-1.94 1.94V5.31c0-.38-.31-.68-.68-.68s-.68.31-.68.68v5.79L8.38 9.05a.555.555 0 0 0-.79 0c-.22.22-.22.57 0 .79l3.13 3.13ZM15.57 13.6c-.36 0-.65.29-.65.65v.89c0 .12-.08.24-.24.24H7.53c-.09 0-.24-.05-.24-.24v-.89c0-.36-.29-.65-.65-.65s-.65.29-.65.65v.89c0 .97.79 1.55 1.55 1.55h7.15c.97 0 1.55-.79 1.55-1.55v-.89a.65.65 0 0 0-.66-.65Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 0C4.92 0 0 4.92 0 11s4.92 11 11 11 11-4.92 11-11S17.08 0 11 0m0 20.31c-5.14 0-9.31-4.17-9.31-9.31S5.86 1.69 11 1.69s9.31 4.17 9.31 9.31-4.17 9.31-9.31 9.31"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }